const THREE = require('three');

class Camera extends THREE.PerspectiveCamera {
    constructor(fov, aspect, near, far, { element } = {}) {
        super(fov, aspect, near, far);

        this.position.y = 35;
    }

}

export default Camera;